import { api } from '@/lib/api'

import { DolarAppSearchRecipient } from '../types'

export function getDolarAppUsers(dolarTag: string) {
  return api.get<DolarAppSearchRecipient[]>(
    `/v1/me/accounts/search-by-alias/${dolarTag}`,
  )
}
